import { TPartnerInformationPayload } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export type TValidatePartnerShareableLinkTokenParams = { accessToken: string };

export const validatePartnerShareableLinkToken = (axios: IAxiosInstance) => {
  return async (
    body: TValidatePartnerShareableLinkTokenParams
  ): Promise<TPartnerInformationPayload> => {
    const response = await axios.noRetry.post<{
      data: TPartnerInformationPayload;
    }>("/api/validatePartnerShareableLinkToken", body);
    return response.data.data;
  };
};
